import React, { useState, useEffect } from "react";
import landingData from "../data/Page.json"
import { createContext } from "react";
export const PatentContext = createContext();
export default function PatentContextProvider({ children }) {
  const [landingPageData, setLandingPageData] = useState(landingData?.landingPagePalm)
  const [audioPlayed, setAudioPlayed] = useState(false);
  const [patentLicensingModal, setPatentLicensingModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState(() => {
    const checkActiveLink = localStorage.getItem("activelink");
    try {
      return checkActiveLink ? JSON.parse(checkActiveLink) : null;
    } catch (error) {
      return null;
    }
  });
 
const [active, setActive] = useState(() => {
const checkActivePatent = localStorage.getItem("activePatent");
  try {
      return checkActivePatent ? JSON.parse(checkActivePatent) : null;
    } catch (error) {
      return null;
    }
  });

  const [animate, setAnimate] = useState(() => {
    const checkAnimation = localStorage.getItem("animate");
    return checkAnimation ? JSON.parse(checkAnimation) : true;
  });

  const [playMusic, setPlayMusic] = useState(() => {
    const checkMusicPlay = localStorage.getItem("playMusic");
    return checkMusicPlay ? JSON.parse(checkMusicPlay) : false;
  });
  
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [allPages, setAllPages] = useState([]);
  // Video State
  const [videoCurrentTime, setVideoCurrentTime] = useState(
    localStorage.getItem("videoCurrentTime") || 0
  );

  useEffect(() => {
    localStorage.setItem("videoCurrentTime", videoCurrentTime);
  }, [videoCurrentTime]);

  useEffect(() => {
    setLandingPageData(landingData.landingPagePalm)
  }, [videoCurrentTime]);

  const handleLinkClick = (path) => {
    setActiveLink(path);
    localStorage.setItem("activelink", JSON.stringify(path));
  };
  
  return (
    <PatentContext.Provider
      value={{
        landingPageData,
        isLoading,
        setLoading,
        error,
        setError,
        setVideoCurrentTime,
        audioPlayed,
        setAudioPlayed,
        playMusic,
        setPlayMusic,
        animate,
        setAnimate,
        active,
        setActive,
        menuOpen,
        setMenuOpen,
        handleLinkClick,
        activeLink,
        patentLicensingModal,
        setPatentLicensingModal,
        setActiveLink,
        menuOpen,
        allPages,
        setAllPages,
      }}
    >
      {children}
    </PatentContext.Provider>
  );
}
